module.exports = __webpack_public_path__ + "static/finding-gold-e5281df54a2c973569da62b19022462f.webp";